
// **** Autogenerated. Do NOT edit. ****

package uk.co.nickthecoder.glok.property.boilerplate

import uk.co.nickthecoder.glok.property.*
import kotlin.reflect.KClass
import uk.co.nickthecoder.glok.documentation.Boilerplate 


    
// region ==== Stylable ====
/**
 * [Boilerplate] which avoids having to use generics.
 *
 * A subclass of [SimpleBooleanProperty], which also stores the pre-styled value, so that if the style is removed,
 * then the pre-styled value can be reinstated.
 */
class StylableBooleanProperty( initialValue: Boolean, bean: Any? = null, beanName: String? = null) :
    SimpleStylableProperty<Boolean>(initialValue, bean, beanName), BooleanProperty {
    override fun kclass() : KClass<*> = Boolean::class
}

fun stylableBooleanProperty(initialValue: Boolean) = PropertyDelegate<Boolean,StylableBooleanProperty>(initialValue) { bean, name, value ->
    StylableBooleanProperty(value, bean, name)
}
// endregion Stylable


// region ==== Optional Stylable ====
/**
 * [Boilerplate] which avoids having to use generics.
 *
 * A subclass of [SimpleOptionalBooleanProperty], which also stores the pre-styled value, so that if the style is removed,
 * then the pre-styled value can be reinstated.
 */
class StylableOptionalBooleanProperty(initialValue: Boolean?, bean: Any? = null, beanName: String? = null) :
    SimpleStylableProperty<Boolean?>(initialValue, bean, beanName), OptionalBooleanProperty {
    override fun kclass() : KClass<*> = Boolean::class
}

fun stylableOptionalBooleanProperty(initialValue: Boolean?) = PropertyDelegate<Boolean?,StylableOptionalBooleanProperty>(initialValue) { bean, name, value ->
    StylableOptionalBooleanProperty(value, bean, name)
}

// endregion Optional Stylable


